var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AlfApproverList',{attrs:{"isLoading":_vm.isLoading,"history":_vm.history,"list":_vm.list},on:{"fetch":_vm.fetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }